import React from "react";
import { useTranslation } from "react-i18next";
import "./index.css";
import WasteProcessing44Header from "./Header";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";
import Flow44_1 from "./Flow44_1";

const ProdWasteProcessing44Components = ({ productId }) => {
  const { t } = useTranslation();
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="waste-processing-44-container" id="waste-processing-44-id">
      <WasteProcessing44Header productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="waste-processing-44-content">
          {/* Flow 44.1 */}
          <Flow44_1 productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdWasteProcessing44Components;

